/* LiquorVerse hero slideshow (storefront-prototype-v7).
   6s autoplay, arrows/dots, pause on hover, no autoplay under
   prefers-reduced-motion. */
(function () {
  'use strict';

  function init(hero) {
    var slides = hero.querySelectorAll('.lv-slide');
    var dots = hero.querySelectorAll('.lv-dot');
    if (slides.length < 2) return;

    var idx = 0;
    var timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(n) {
      slides[idx].classList.remove('active');
      if (dots[idx]) dots[idx].classList.remove('active');
      idx = (n + slides.length) % slides.length;
      slides[idx].classList.add('active');
      if (dots[idx]) dots[idx].classList.add('active');
    }
    function next() { go(idx + 1); }
    function start() { if (!reduced && !timer) timer = setInterval(next, 6000); }
    function stop() { clearInterval(timer); timer = null; }
    function reset() { stop(); start(); }

    var nextBtn = hero.querySelector('.lv-arrow--next');
    var prevBtn = hero.querySelector('.lv-arrow--prev');
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); reset(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1); reset(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.goto, 10)); reset(); });
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);

    /* ---- Swipe [Ethan 2026-08-09] ----
       The arrows are display:none below 900px (they sat on top of the primary
       CTA), which left the dots as the only way to change slide on a phone —
       and nobody expects to hunt for dots on a banner. Touch now moves it.

       Deliberately NON-blocking: listeners are passive and nothing calls
       preventDefault, so vertical page scrolling is untouched. The gesture is
       judged only on touchend, and it must be BOTH far enough (40px) and
       clearly more horizontal than vertical (1.4x) — otherwise a diagonal
       scroll up the page would flip the banner under the reader's thumb.
       A tap moves a few pixels at most, so buttons and links still work. */
    var sx = 0, sy = 0, tracking = false;

    hero.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }   // ignore pinch
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      tracking = true;
      stop();                                                     // don't advance under the finger
    }, { passive: true });

    hero.addEventListener('touchend', function (e) {
      if (!tracking) { start(); return; }
      tracking = false;
      var t = e.changedTouches && e.changedTouches[0];
      if (!t) { start(); return; }
      var dx = t.clientX - sx;
      var dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        go(dx < 0 ? idx + 1 : idx - 1);                           // left = forward
      }
      reset();
    }, { passive: true });

    hero.addEventListener('touchcancel', function () { tracking = false; start(); }, { passive: true });

    start();
  }

  function boot() {
    document.querySelectorAll('[data-lv-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
